import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LgvUserService, LgvTSHelper } from '../../core/core.module';
import { LgvModel } from '../../data-models/longevity.model';
import { filter } from 'rxjs';

@Component({
  selector: 'lgv-agent-signature',
  templateUrl: './agent-signature.component.html',
  styleUrls: ['./agent-signature.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentSignatureComponent implements OnInit {

  dbUserSS: LgvModel.AgentSS;

  constructor(public lgvUserSvc: LgvUserService,) { }

  ngOnInit(): void {
    this.lgvUserSvc.DBUserSS$.pipe(filter(f => !!f)).subscribe(ss => {
      this.dbUserSS = ss;
    });
  }

  get mloClientRegistrationRelativeLink(): string { return `/mlo-csr/${this.dbUserSS.agentInfo.id}` }

  get mloClientRegistrationLink(): string {
    return `${LgvTSHelper.environmentBaseUrl}#${this.mloClientRegistrationRelativeLink}?c=${this.dbUserSS.company.companyCode}`;
  }
}
